// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import TagManager from '@sooro-io/react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-W6JBM9K7' // Replace with your GTM Container ID
};

TagManager.initialize(tagManagerArgs);

// import * as Sentry from "@sentry/browser";
// import { BrowserTracing } from "@sentry/tracing";

// Sentry.init({
//   dsn: "https://7eefaabd99764178b805e15635e2948f@o1365005.ingest.sentry.io/4504396725813248",
//   integrations: [new BrowserTracing()],

//   tracesSampleRate: 1.0
// });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
